import { render, staticRenderFns } from "./elementTable.vue?vue&type=template&id=36daae5a"
import script from "./elementTable.vue?vue&type=script&lang=js"
export * from "./elementTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports